module.exports = __webpack_public_path__ + "static/media/emma_vp_timeline_1.b18b4bc7.jpg";